<template>
  <div>
    <el-form :model="model" label-width="12em" class="form-group">
      <el-form-item label="Name">
        <el-input v-model="model.name" placeholder="Enter device name" />
      </el-form-item>
      <el-form-item label="Connect Name">
        <el-input v-model="model.connectName" placeholder="Enter connect name" />
      </el-form-item>
      <el-form-item label="Asset Image URL">
        <el-input v-model="model.assetImageUrl" placeholder="Enter asset image URL">
          <template #append>
           <i class="el-icon-link"></i>
          </template>
        </el-input>
      </el-form-item>
    </el-form>
    <span class="flex flex-row justify-end">
      <el-button @click="handleCancel">Cancel</el-button>
      <el-button type="primary" @click="handleConfirm">Confirm</el-button>
    </span>
  </div>
</template>

<script>
import { createThirdPartyAsset } from "@/api";
export default {
  name: "AcknowledgeDialog",
  emits: ["confirm", "cancel"],
  props: {
    id: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      model: {
        name: "",// "vibration-1281013",
        connectName: "",//"imonnit"
        assetImageUrl: ""
      }
    };
  },
  methods: {
    handleCancel() {
      this.$emit("cancel");
    },
    async handleConfirm() {
      this.loading = true;
      try {
        await createThirdPartyAsset(this.model);
        this.$emit("confirm");
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.form-group {
  margin-bottom: 16px;
}
</style>